import { getDataFromStorage } from "../../../util";
import RecommendedProfileSvg from "../../../Svg/RecommendedProfileSvg";
import Button from "../../Button";
import { useNavigate } from "react-router-dom";
import { UserReportContext } from "../../../context/UserReportContext";
import { useContext, useEffect, useState } from "react";
import AlertContext from "../../../context/AlertContext";
import Tooltip from "../../CommonComponents/Tooltip";
const RecommendedCard = ({ lid, bid, name, graduation, img, scores = {}, recommendedFor }) => {

  const navigate = useNavigate();
  const UserReportCxt = useContext(UserReportContext);
  let role = getDataFromStorage("role");

  const Alert = useContext(AlertContext);

  useEffect(() => {
    Alert.setFromResommended(true);
    UserReportCxt.setCurrentLearnerDetails({
      label: name,
      value: lid,
    });
  }, []);

  const handleTestpoints = () => {
    Alert.setStudentDetailSL({
      sname: name,
      degree: graduation,
      profile: img
    })
    Alert.setSelectedBid({ bid: bid, lid: lid });
    navigate("/profiles/testpoints");
  }

  if (role === "admin" || role === "customer") {
    return (
      <div className="recommendedCardContainer">
        <div className="recommendedCardTopDetails">
          <div className="recommendedCardTitleContainer">
            <p className="recommendedCardName">{name}</p>
            <p className="recommendedCardGraduation">{graduation}</p>
          </div>
          <div className="recommendedCardImage">
            <img src={img}></img>
          </div>
        </div>
        <div className="recommendedCardMiddleDetails">
          {scores
            .map((score) => ({
              ...score,
              percentage: ((score.totalScore / score.targetScore) * 100).toFixed(2),
            })) // Add the percentage to each score
            .sort((a, b) => b.percentage - a.percentage) // Sort by percentage in descending order
            .slice(0, 3) // Get the top 3 scores
            .map((score, index) => (
              <>
                <div key={index} className="recommendedCardScore">
                  <p className="scoreName">{score.name}</p>
                  {score.totalScore && score.targetScore ? (
                    <p className="scoreValue">
                      {score.percentage}%
                    </p>
                  ) : (
                    <p className="scoreValue">N/A</p>
                  )}
                </div>
                <hr />
              </>
            ))}
        </div>
        <div className="recommendedCardBottomDetails">
          <div className="recommendedCardBottomDetailsLeft">
            <p className="recommendedForLabel">Recommended for:</p>
            <p className="recommendedCardRole">{recommendedFor}</p>
          </div>
          <div className="recommendedCardBottomDetailsRight">
            <Button
              size="sm"
              hierarchy={{ type: "secondaryGrey", buttonText: "Report" }}
              icon={{ type: "leading", icon: <RecommendedProfileSvg /> }}
              onClick={handleTestpoints}
            />
            {/* <button className="recommendedCardProfileButton"><RecommendedProfileSvg className="recommendedProfileSvg"></RecommendedProfileSvg>Profile</button> */}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <></>
    )
  }
}

{/* <RecommendedCard
  name={"tushar"}
  graduation={"Btech CSE"}
  img={""}
  scores={[1, 2, 3]}
  recommendedFor={"SDE Intern"}
/> */}

export default RecommendedCard;